// src/stores/app/onboardingAoVivoStore.ts
//
// Conexões Meta do cliente acontecendo agora (onboarding ao vivo). Retrato via
// GET /meta-onboarding/ao-vivo ao iniciar a sessão; atualizações pelo socket
// (`META_ONBOARDING_PROGRESSO`, salas do usuário e da inbox). Alimenta a barra
// flutuante do painel, que sobrevive a fechar o InboxModal e a recarregar.

import { defineStore } from 'pinia';
import {
    MetaOnboardingAoVivoClienteService,
    type ItemAoVivoCliente,
} from '@/services/meta-trilha/meta-onboarding-ao-vivo.service';

const MINUTOS_RECENTE = 30;

export const useOnboardingAoVivoClienteStore = defineStore('onboarding-ao-vivo-cliente', {
    state: () => ({
        itens: {} as Record<string, ItemAoVivoCliente>,
        // Execuções que o cliente dispensou no X (só as encerradas podem ser dispensadas).
        dispensadas: [] as string[],
    }),

    getters: {
        visiveis(state): ItemAoVivoCliente[] {
            const limite = Date.now() - MINUTOS_RECENTE * 60_000;
            return Object.values(state.itens)
                .filter((i) => !state.dispensadas.includes(i.idExecucao))
                .filter((i) => i.status === 'EM_ANDAMENTO'
                    || !!i.acompanhamento
                    || i.wame?.situacao === 'AGUARDANDO_ROTEAMENTO'
                    || (i.encerradoEm && new Date(i.encerradoEm).getTime() >= limite))
                .sort((a, b) => b.ultimaAtividadeEm.localeCompare(a.ultimaAtividadeEm));
        },
    },

    actions: {
        async carregar() {
            try {
                const lista = await new MetaOnboardingAoVivoClienteService().listar();
                const novo: Record<string, ItemAoVivoCliente> = {};
                for (const i of lista ?? []) novo[i.idExecucao] = i;
                this.itens = novo;
            } catch {
                // Server sem a rota (deploy antigo): a barra simplesmente não aparece.
            }
        },

        aplicar(item: ItemAoVivoCliente) {
            if (!item?.idExecucao) return;
            this.itens = { ...this.itens, [item.idExecucao]: item };
        },

        dispensar(idExecucao: string) {
            if (!this.dispensadas.includes(idExecucao)) this.dispensadas.push(idExecucao);
        },
    },

    persist: { pick: ['dispensadas'] },
});
